(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.discount-badge__copy-btn');
      if (!btn) return;
      var text = btn.dataset.copyText;
      if (!text) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
          .then(function () { showCopied(btn); })
          .catch(function () { fallbackCopy(text, btn); });
      } else {
        fallbackCopy(text, btn);
      }
    });

    function showCopied(btn) {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
    }

    function fallbackCopy(text, btn) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        showCopied(btn);
      } catch (err) {
        console.warn('[discount-badge] Copy failed:', err);
      }
    }

    function updateBadgesForVariant(variantPrice) {
      var wrappers = document.querySelectorAll('[data-discount-badge]');
      wrappers.forEach(function (wrapper) {
        var pct = parseInt(wrapper.dataset.discountPercent, 10);
        if (!pct || !variantPrice) return;

        var discountAmt   = Math.round(variantPrice * pct / 100);
        var discountedAmt = variantPrice - discountAmt;

        var priceEl = wrapper.querySelector('[data-discount-price]');
        if (!priceEl) return;

        priceEl.textContent = formatMoney(discountedAmt);
        wrapper.dataset.originalPrice = variantPrice;
      });
    }

    /* ── Event: Dawn / most themes — fires on document ── */
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.price) updateBadgesForVariant(v.price);
    });

    /* ── Event: some themes use this name ── */
    document.addEventListener('variantChanged', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.price) updateBadgesForVariant(v.price);
    });

    /* ── Event: Shopify product-form web component ── */
    document.addEventListener('change', function (e) {
      var form = e.target.closest('product-form, [data-product-form]');
      if (!form) return;
      setTimeout(function () { tryReadVariantFromForm(form); }, 80);
    });

    function tryReadVariantFromForm(form) {
      var input = form.querySelector('input[name="id"]');
      if (!input) return;
      var id = input.value;
      var variants = window.__discountBadgeVariants || [];
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (v && v.price) updateBadgesForVariant(v.price);
    }

    function formatMoney(cents) {
      var moneyFormat =
        (window.Shopify && window.Shopify.money_format) ||
        (window.theme && window.theme.moneyFormat) ||
        '{{amount}}';

      var amount       = (cents / 100).toFixed(2);
      var amountInt    = Math.round(cents / 100).toString();
      var amountComma  = amount.replace('.', ',');
      var currency     = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g,                    amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,        amountInt)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
        .replace(/\{\{\s*amount_with_currency\s*\}\}/g,      amount + ' ' + currency)
        .replace(/\{\{\s*amount_no_decimals_with_currency\s*\}\}/g, amountInt + ' ' + currency);
    }

    function init() {
      /* Try to find variant data exposed by theme in a <script type="application/json"> */
      document.querySelectorAll('script[type="application/json"]').forEach(function (tag) {
        try {
          var data = JSON.parse(tag.textContent);
          /* Array of variants directly */
          if (Array.isArray(data) && data[0] && data[0].price !== undefined) {
            window.__discountBadgeVariants = (window.__discountBadgeVariants || []).concat(data);
          }
          /* {variants: [...]} shape */
          if (data && Array.isArray(data.variants)) {
            window.__discountBadgeVariants = (window.__discountBadgeVariants || []).concat(data.variants);
          }
        } catch (e) { /* not JSON — ignore */ }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();
  } catch(e) { console.error(e); }
})();

})();
